<template>
  <div>
    <b-modal
      id="modal-location-vacancies"
      ref="modal_location_vacancies"
      content-class="modal-fullscreen"
      button-size="sm"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      @hidden="onHidden"
      body-class="p-0"
      hide-header
    >
      <location-vacancies
        ref="location_vacancies_component"
        show-details
        show-header
        @close="hideModal"
        :is-disabled="isDisabled"
      />

      <template #modal-footer="{}">
        <div class="w-100 d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center" style="width: 40%;">
            <location-select
              v-if="!hideLinkBtn"
              ref="location_select"
              class="w-100"
              :is-disabled="isDisabled"
              :value="locationId"
              :initial-text="locationName || `id: ${locationId}`"
              drop-up
              @onSelect="handleLocationSelect"
            >
              <template #append-btn="{ onClear, query, disabled }">
                <b-button
                  size="sm"
                  :variant="locationId ? 'outline-danger' : 'outline-primary'"
                  :disabled="disabled || !query"
                  @click="onClear"
                >
                  <font-awesome-icon :icon="locationId ? 'unlink' : 'link'" class="mr-1"/>
                  {{ locationId ? 'Отвязать объект' : 'Привязать объект' }}
                </b-button>
              </template>
            </location-select>
          </div>

          <div>
            <b-button size="sm" variant="secondary" class="mr-2" @click="hideModal()">Отмена</b-button>
            <b-button size="sm" variant="success" :disabled="isDisabled" @click="handleSaveVacancies()">Сохранить</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import helpers from "../../utilites/helpers";
  import LocationSelect from "../Locations/LocationSelect";
  import LocationVacancies from "../Locations/LocationVacancies.vue";

export default {
  name: 'RecruitLocationVacancy',
  components: { LocationVacancies, LocationSelect },
  mixins: [ helpers ],
  data() {
    return {
      locationId: null,
      locationName: '',
      vacancyId: null,
      isDisabled: false,
      hideLinkBtn: false
    }
  },
  methods: {
    async showModal(vacancyId = null, isView = false, locationId = null, locationName = '', forceCreate, hideLink) {
      this.vacancyId = vacancyId;
      this.isDisabled = isView;
      this.locationId = locationId;
      this.locationName = locationName;
      this.hideLinkBtn = hideLink;

      this.$refs.modal_location_vacancies.show();

      this.$nextTick(() => {
        this.$refs.location_vacancies_component.configure(this.locationId, this.locationName, this.vacancyId, forceCreate);
      });
    },
    hideModal() {
      this.$refs.modal_location_vacancies.hide();
    },
    onHidden() {
      this.$emit('modal-closed');
    },
    handleLocationSelect(id, item) {
      if (id === 0) {
        this.locationId = null;
        this.locationName = '';
      } else {
        this.locationId = id;
        this.locationName = item ? item.name : '';
      }

      this.$refs.location_vacancies_component.updateLocation(this.locationId, this.locationName);
    },

    async handleSaveVacancies() {
      if (this.$refs.location_vacancies_component) {
        const location = { id: this.locationId, name: this.locationName };

        if (this.$refs.location_vacancies_component) {
          if (!this.$refs.location_vacancies_component.items.every(v => v.vacancy_id > 0)) {
            this.showSubmitError('Выберите вакансию объекта.');
            return;
          }

          if (!this.$refs.location_vacancies_component.items.every(v => v.workers_count > 0)) {
            this.showSubmitError('Укажите требуемое количество исполнителей.');
            return;
          }
        }

        const result = await this.$refs.location_vacancies_component.saveVacancies(location);

        if (result && result.success) {
          this.$bvToast.toast('Вакансии успешно сохранены.', {
            title: 'Успех', variant: 'success', autoHideDelay: 3000, solid: true
          });

          this.loading = false;
          this.$emit('refresh');
          this.hideModal();

          this.$refs.modal_location_vacancies.hide();
        } else {
          this.$bvToast.toast('Ошибка при сохранении вакансий.', {
            title: 'Ошибка', variant: 'danger', autoHideDelay: 3000, solid: true
          });
        }
      }
    },
  }
}
</script>

<style>
#modal-location-vacancies .modal-dialog {
  max-width: 100% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen {
  max-height: 100% !important;
  height: 100% !important;
}

.modal-body-fullscreen {
  padding-bottom: 0  !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Recruiting/RecruitLocationVacancy.vue